<script setup lang="ts">
// Ports v3 `Skeletons/TableSkeleton.vue` one-to-one for the report table's first load. v3 never
// mounted the table while `tableData` was empty (`OrphexReportTable.vue` gates it on
// `columns.length && tableData.length`), so the cold load showed ten borderless placeholder rows
// and a pager silhouette — not a header over skeleton cells. Every fill is the gray step the v3
// class used (`Skeleton`'s ramp tones); radii are v3's Tailwind defaults, since this design system
// remaps `rounded-md`. The wrapper's `px-4 py-6` is v3 `OrphexLoadingText`'s skeleton frame.
import { Skeleton } from '@/shared/ui'

const RADIUS_MD = '0.375rem'
</script>

<template>
  <div class="report-table-skeleton w-full px-4 py-6" aria-hidden="true">
    <div class="w-full animate-pulse py-4 motion-reduce:animate-none">
      <div
        v-for="row in 10"
        :key="row"
        class="report-table-skeleton__row flex items-center gap-4 border border-skeleton-faint p-3"
      >
        <Skeleton v-for="cell in 3" :key="cell" class="flex-1" :radius="RADIUS_MD" tone="soft" />
        <Skeleton
          v-for="cell in 3"
          :key="`fixed-${cell}`"
          width="8rem"
          :radius="RADIUS_MD"
          tone="soft"
        />
      </div>

      <div
        class="report-table-skeleton__footer flex flex-col px-3 pt-4 md:flex-row md:items-center md:justify-between"
      >
        <div class="mb-4 flex items-center gap-2 md:mb-0">
          <Skeleton width="2.25rem" height="2.25rem" :radius="RADIUS_MD" tone="soft" />
          <Skeleton
            v-for="page in 5"
            :key="page"
            width="2.25rem"
            height="2.25rem"
            radius="var(--ui-radius-full)"
            :tone="page === 1 ? 'inverse' : 'soft'"
          />
          <Skeleton width="2.25rem" height="2.25rem" :radius="RADIUS_MD" tone="soft" />
        </div>

        <div class="flex items-center gap-4">
          <Skeleton width="6rem" height="1.25rem" :radius="RADIUS_MD" tone="soft" />
          <Skeleton width="5rem" height="2.25rem" :radius="RADIUS_MD" tone="soft" />
        </div>
      </div>
    </div>
  </div>
</template>
